<template>
  <svg :width="width" :height="height" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 31C2 14.9837 14.9837 2 31 2C47.0163 2 60 14.9837 60 31C60 34.889 59.2339 38.6017 57.8435 41.9933L55.993 41.2347C57.2864 38.0796 58 34.6244 58 31C58 16.0883 45.9117 4 31 4C16.0883 4 4 16.0883 4 31C4 45.9117 16.0883 58 31 58C38.5965 58 45.4589 54.8641 50.3662 49.8136L50.3798 49.8268C50.4531 49.7258 50.537 49.6302 50.6313 49.5417C51.4367 48.7858 52.7024 48.8259 53.4583 49.6313L69.6401 66.8732C70.396 67.6786 70.3558 68.9443 69.5504 69.7002C68.745 70.4561 67.4793 70.4159 66.7234 69.6105L50.5713 52.4003C45.4139 57.1194 38.5426 60 31 60C14.9837 60 2 47.0163 2 31Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31 22C26.727 22 22.8088 22.9216 19.9228 24.4608C17.0798 25.9771 15 28.2418 15 31C15 33.7582 17.0798 36.0229 19.9228 37.5392C22.8088 39.0784 26.727 40 31 40C35.273 40 39.1912 39.0784 42.0772 37.5392C44.9202 36.0229 47 33.7582 47 31C47 28.2418 44.9202 25.9771 42.0772 24.4608C39.1912 22.9216 35.273 22 31 22ZM17 31C17 29.34 18.2781 27.6046 20.864 26.2255C23.4069 24.8693 26.9888 24 31 24C35.0112 24 38.5931 24.8693 41.136 26.2255C43.7219 27.6046 45 29.34 45 31C45 32.66 43.7219 34.3954 41.136 35.7745C38.5931 37.1307 35.0112 38 31 38C26.9888 38 23.4069 37.1307 20.864 35.7745C18.2781 34.3954 17 32.66 17 31Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31 29C29.8954 29 29 29.8954 29 31C29 32.1046 29.8954 33 31 33C32.1046 33 33 32.1046 33 31C33 29.8954 32.1046 29 31 29ZM27 31C27 28.7909 28.7909 27 31 27C33.2091 27 35 28.7909 35 31C35 33.2091 33.2091 35 31 35C28.7909 35 27 33.2091 27 31Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ScreeningToolsIllustration',
  props: {
    width: {
      type: Number,
      default: 72,
    },
    height: {
      type: Number,
      default: 72,
    },
  },
};
</script>
